import { mobile } from "../Agent"

const makeItM3U8 = (video) => {
    if (video.indexOf("cdnwiz") < 0) return video;
    if (video.length < 3) return video;

    var _video = video.replace("mediadownload.ynet.co.il/", "ynethd-i.akamaihd.net/i/");
    _video = (mobile() ? makeItMobile(_video) : _video);

    if (video.indexOf("_800.mp4") > 0 && video.indexOf("_1600.mp4") < 1) {
        _video = _video.replace("_800.mp4", "_,800,.mp4");
    }
    if (video.indexOf("_1600.mp4") > 0 && video.indexOf("_800.mp4") < 1) {
        _video = _video.replace("_1600.mp4", "_,800,1600,.mp4");
    }
    if (video.indexOf("_360p.mp4") > 0 && video.indexOf("_800.mp4") < 1 && video.indexOf("_1600.mp4") < 1) {
        _video += "/master.m3u8";
    } else {
        _video += ".csmil/master.m3u8";
    }
    return _video;
}

const makeItMobile = (m3u8Video) => {
    return m3u8Video.replace("ynethd-i.akamaihd.net", "vod.ynet-cdnwiz.com");
}

export {
    makeItM3U8
}


// WEBPACK FOOTER //
// ./src/Components/Services/Flowplayer/m3u8.js